// extracted by mini-css-extract-plugin
module.exports = {"filter-item-wrapper":"PriceRange_filter-item-wrapper__NYc01","filter-item-container":"PriceRange_filter-item-container__zFKjY"};